import { curry } from 'ramda'
import { locationDetailIncludes } from '../utils'

const componentDetailToLocationDetailsRule = {
  name: 'componentDetailToLocationDetails',
  rule: curry((__, component, location) => {
    if (!component.locationDetail || component.locationDetail === '')
      return true
    return locationDetailIncludes(component, location)
  }),
}

const pocMsfDetailRule = {
  name: 'pocMsfDetailRule',
  rule: curry((__, ___, location) => {
    const { detail } = location
    return detail === 'LM' || detail === 'POC'
  }),
}

export const rules = {
  defaults: [componentDetailToLocationDetailsRule],
  LM: [pocMsfDetailRule],
  POC: [pocMsfDetailRule],
}
